const normalizeName = (value = '') =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');

function editDistance(left, right) {
  const previous = Array.from({ length: right.length + 1 }, (_, index) => index);

  for (let row = 1; row <= left.length; row += 1) {
    let diagonal = previous[0];
    previous[0] = row;

    for (let column = 1; column <= right.length; column += 1) {
      const above = previous[column];
      const cost = left[row - 1] === right[column - 1] ? 0 : 1;
      previous[column] = Math.min(
        previous[column] + 1,
        previous[column - 1] + 1,
        diagonal + cost
      );
      diagonal = above;
    }
  }

  return previous[right.length];
}

function nameSimilarity(left, right) {
  if (left === right) return 1;
  const longest = Math.max(left.length, right.length);
  if (!longest) return 0;
  return 1 - editDistance(left, right) / longest;
}

function getMatchScore(first, second, similarity) {
  const firstYear = Number(first.birthYear) || null;
  const secondYear = Number(second.birthYear) || null;

  if (firstYear && secondYear) {
    const yearGap = Math.abs(firstYear - secondYear);
    if (yearGap > 2) return similarity >= 0.94 ? 76 : 0;
    return Math.round(82 + similarity * 16);
  }

  return Math.round(72 + similarity * 20);
}

export function findLikelyDuplicateMembers(nodes = []) {
  const candidates = (nodes ?? [])
    .filter(node => node?.id && typeof node?.name === 'string')
    .map(node => ({ node, normalizedName: normalizeName(node.name) }))
    .filter(item => item.normalizedName.length > 1);
  const matches = [];

  for (let firstIndex = 0; firstIndex < candidates.length; firstIndex += 1) {
    for (let secondIndex = firstIndex + 1; secondIndex < candidates.length; secondIndex += 1) {
      const first = candidates[firstIndex];
      const second = candidates[secondIndex];
      const similarity = nameSimilarity(first.normalizedName, second.normalizedName);
      const yearsMatch = !first.node.birthYear || !second.node.birthYear
        || Math.abs(Number(first.node.birthYear) - Number(second.node.birthYear)) <= 2;
      const exactName = first.normalizedName === second.normalizedName;
      const likelyTypo = similarity >= 0.84 && yearsMatch;
      const likelyVariant = similarity >= 0.92
        && (!first.node.birthYear || !second.node.birthYear);

      if (!exactName && !likelyTypo && !likelyVariant) continue;

      matches.push({
        first: first.node,
        second: second.node,
        score: getMatchScore(first.node, second.node, similarity),
        reason: exactName
          ? 'Matching names'
          : 'Similar names' + (yearsMatch ? ' and birth years' : ''),
      });
    }
  }

  return matches.sort((left, right) => right.score - left.score);
}